import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";

import DuplicationData from "./DuplicationData";

const Summary = () => {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    fetch(`/api/getDedup?id=${id}`)
      .then((response) => response.json())
      .then((data) => {

        setRecords(data);
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }, [id]);

  return (
    <Box m={4}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <DuplicationData records={records} />
        // <MergeDuplication records={records} onMerge={handleMerge} />
      )}
    </Box>
  );
};

export default Summary;
